import { isMobile } from "react-device-detect";
import "./inputs.css";
export default function Inputs({
  title,
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  name,
  type
}) {
  return (
    <>
      <div className="space-text">
        <div className="title">{title}</div>

        <input
          type={type}
          name={name}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values}
          className={isMobile ? "inputTextMobile" : "inputText"}
        />
        <span className="error-text">{errors && touched && errors}</span>
      </div>
    </>
  );
}
